import { Box } from '@mui/material'
import ContainerLengthBayMappingsTable from '@yard/features/container-length-bay-mappings/components/ContainerLengthBayMappingsTable'
import ContainerLengthBayMappingsTableDialog from '@yard/features/container-length-bay-mappings/components/ContainerLengthBayMappingsTableDialog'

const ContainerLengthBayMappingsPage = () => {
  return (
    <Box>
      <ContainerLengthBayMappingsTable />
      <ContainerLengthBayMappingsTableDialog />
    </Box>
  )
}

export default ContainerLengthBayMappingsPage
